module.exports = __webpack_public_path__ + "img/footer.d2b99d82.jpg";